module.exports = __webpack_public_path__ + "img/05.dd693fb9.png";